<template>
  <section class="" :style="{ background: backgroundSection }">
    <div class="max-w-screen-xl px-4 py-8 mx-auto lg:px-0 lg:py-16 2xl:px-0 lg:px-4">
      <div class="max-w-4xl mx-auto font-bold text-center text-white h2 md:px-10 font-ww-medium" v-html="sectionTitle">
      </div>

      <div class="grid grid-cols-1 mt-8 md:mt-10 md:grid-cols-2 gap-y-4 lg:gap-x-14 md:gap-x-6">
        <!-- First column -->
        <div class="space-y-8 md:space-y-12">
          <div v-for="(item, index) in questions.slice(0, questions.length / 2)" :key="index">
            <div class="p-3 space-y-6 text-white border border-black cursor-pointer sm:p-6 md:p-6 lg:p-8 rounded-3xl"
              @click="toggleVisibility(item.id)">
              <div class="flex items-center justify-between gap-x-2">
                <div class="h3 font-ww-medium">{{ item.question }}</div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="32px" height="19px" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                      d="M16.326,18.257 C15.683,18.386 14.989,18.202 14.490,17.703 L0.867,4.080 C0.075,3.289 0.074,2.005 0.865,1.214 C1.656,0.423 2.939,0.424 3.731,1.216 L16.023,13.508 L28.324,1.207 C29.115,0.416 30.398,0.417 31.190,1.209 C31.982,2.001 31.983,3.284 31.192,4.075 L17.587,17.680 C17.235,18.032 16.785,18.218 16.326,18.257 Z" />
                  </svg>
                </div>
              </div>

              <div class="pt-2" v-show="item.visible">
                <div class="font-light font-ww-regular h4" v-html="item.answer"></div>
                <ul class="grid pl-5 gap-y-1" v-if="item.list" :class="item.listType">
                  <li v-for="(listItem, idx) in item.list" :key="idx">{{ listItem }}</li>
                </ul>
                <p class="m-4" v-if="item.extraText" v-html="item.extraText"></p>
              </div>
            </div>
          </div>
        </div>

        <!-- Second column -->
        <div class="space-y-8 md:space-y-12">
          <div v-for="(item, index) in questions.slice(questions.length / 2, questions.length)" :key="index">
            <div class="p-3 space-y-6 text-white border border-black cursor-pointer sm:p-6 md:p-6 lg:p-8 rounded-3xl"
              @click="toggleVisibility(item.id)">
              <div class="flex items-center justify-between gap-x-2">
                <div class="h3 font-ww-medium">{{ item.question }}</div>
                <div>
                  <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="17px" viewBox="0 0 24 24">
                    <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
                      d="M16.326,18.257 C15.683,18.386 14.989,18.202 14.490,17.703 L0.867,4.080 C0.075,3.289 0.074,2.005 0.865,1.214 C1.656,0.423 2.939,0.424 3.731,1.216 L16.023,13.508 L28.324,1.207 C29.115,0.416 30.398,0.417 31.190,1.209 C31.982,2.001 31.983,3.284 31.192,4.075 L17.587,17.680 C17.235,18.032 16.785,18.218 16.326,18.257 Z" />
                  </svg>
                </div>
              </div>

              <div class="pt-2" v-show="item.visible">
                <div class="font-light font-ww-regular h4" v-html="item.answer"></div>
                <ul class="grid pl-5 gap-y-1" v-if="item.list">
                  <li v-for="(listItem, idx) in item.list" :key="idx">{{ listItem }}</li>
                </ul>
                <p class="m-4" v-if="item.extraText" v-html="item.extraText"></p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-center mt-8 md:mt-10">
        <button @click="scrollTo(scrollTarget)" :style="{ background: backgroundButton }"
          class="flex items-center bnt-basic md-max:w-full">
          <span class="flex items-center text-white">{{ buttonText }}</span>
          <svg class="relative ml-4 top-0.5 sm:w-auto w-8" xmlns="http://www.w3.org/2000/svg" width="26px" height="19px"
            viewBox="0 0 38 31">
            <path fill-rule="evenodd" fill="rgb(255, 255, 255)"
              d="M37.423,17.013 L24.160,30.420 C23.389,31.199 22.139,31.200 21.369,30.422 C20.599,29.643 20.600,28.381 21.371,27.601 L31.183,17.683 L1.631,17.683 C0.730,17.683 -0.001,16.945 -0.001,16.033 L-0.001,15.338 C-0.001,14.426 0.730,13.688 1.631,13.688 L31.541,13.688 L21.362,3.398 C20.592,2.619 20.593,1.357 21.364,0.577 C22.135,-0.202 23.384,-0.203 24.154,0.575 L37.401,13.965 C37.743,14.311 37.924,14.754 37.962,15.206 C38.088,15.839 37.909,16.522 37.423,17.013 Z" />
          </svg>
        </button>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  backgroundSection: {
    type: String,
    default: "#E28831"
  },
  backgroundButton: {
    type: String,
    default: "#AC4F35"
  },
  scrollTarget: {
    type: String,
    default: "the-products"
  },
  buttonText: {
    type: String,
    default: "Try it now"
  },
  sectionTitle: {
    type: String,
    default: "Frequently Asked Questions",
  },
  questions: {
    type: Array,
    default: () => [
      {
        question: "How much caffeine is in this coffee?",
        answer: "We use our popular medium roast coffee in every bag of Cognition and upgrade it with high-potency mushroom extracts. Therefore, each cup of coffee contains a standard amount of caffeine you’d find in any high-quality Arabica coffee.",
        visible: true,
        id: 0,
      },
      {
        question: "Is it organic?",
        answer: "Yes. Both the coffee and the mushroom extracts are 100% certified organic.",
        visible: false,
        id: 1,
      },
      {
        question: "Why do you only use two mushrooms?",
        answer: "Lifeboost Cognition includes the two most effective mushrooms for the brain and body (Lion’s Mane + Chaga). We include only high-potency extracts from real mushrooms proven to include sufficient amounts of health-boosting beta-glucans.",
        visible: false,
        id: 2,
      },
      {
        question: "Are there any additives or sweeteners?",
        answer: "Nope! Lifeboost Cognition coffee is sugar-free, gluten-free, grain-free, non-GMO, and Kosher.",
        visible: false,
        id: 3,
      },
      {
        question: "Are functional mushrooms the same as magic mushrooms? Will they make my trip?",
        answer: "These are not psychedelic mushrooms. The two mushrooms used in Cognition, Lion’s Mane and Chaga, have absolutely no psychedelic effects whatsoever.",
        visible: false,
        id: 4,
      },
      {
        question: "What does it taste like?",
        answer: "We’ve specially designed Lifeboost Cognition coffee to include the mind-boosting benefits of real mushrooms without the mushroom taste you hear about other mushroom coffees.",
        visible: false,
        id: 5,
      },
      {
        question: "Is it ground coffee or beans?",
        answer: "We only offer Lifeboost Cognition in ground coffee because we want the maximum surface area when we add 100% real mushroom extracts.",
        visible: false,
        id: 6,
      },
    ],
  },
});

function toggleVisibility(index) {
  props.questions.forEach((item) => {
    item.visible = item.id === index ? !item.visible : false;
  });
}

defineBuilderComponent({
  friendlyName: "FrequentlyQuestionsTwoColumns",
  inputs: [
    { name: 'backgroundSection', type: 'color', defaultValue: '#E28831' },
    { name: 'backgroundButton', type: 'color', defaultValue: '#AC4F35' },
    {
      name: "scrollTarget",
      type: "text",
      defaultValue: "the-products"
    },
    {
      name: "buttonText",
      type: "text",
      defaultValue: "Try it now"
    },
    {
      name: "sectionTitle",
      type: "richText",
      defaultValue: "Frequently Asked Questions",
    },
    {
      name: "questions",
      type: "list",
      defaultValue: [
        {
          question: "How much caffeine is in this coffee?",
          answer: "We use our popular medium roast coffee in every bag of Cognition and upgrade it with high-potency mushroom extracts. Therefore, each cup of coffee contains a standard amount of caffeine you’d find in any high-quality Arabica coffee.",
          visible: true,
          id: 0,
        },
        {
          question: "Is it organic?",
          answer: "Yes. Both the coffee and the mushroom extracts are 100% certified organic.",
          visible: false,
          id: 1,
        },
        {
          question: "Why do you only use two mushrooms?",
          answer: "Lifeboost Cognition includes the two most effective mushrooms for the brain and body (Lion’s Mane + Chaga). We include only high-potency extracts from real mushrooms proven to include sufficient amounts of health-boosting beta-glucans.",
          visible: false,
          id: 2,
        },
        {
          question: "Are there any additives or sweeteners?",
          answer: "Nope! Lifeboost Cognition coffee is sugar-free, gluten-free, grain-free, non-GMO, and Kosher.",
          visible: false,
          id: 3,
        },
        {
          question: "Are functional mushrooms the same as magic mushrooms? Will they make my trip?",
          answer: "These are not psychedelic mushrooms. The two mushrooms used in Cognition, Lion’s Mane and Chaga, have absolutely no psychedelic effects whatsoever.",
          visible: false,
          id: 4,
        },
        {
          question: "What does it taste like?",
          answer: "We’ve specially designed Lifeboost Cognition coffee to include the mind-boosting benefits of real mushrooms without the mushroom taste you hear about other mushroom coffees.",
          visible: false,
          id: 5,
        },
        {
          question: "Is it ground coffee or beans?",
          answer: "We only offer Lifeboost Cognition in ground coffee because we want the maximum surface area when we add 100% real mushroom extracts.",
          visible: false,
          id: 6,
        },
      ],
      subFields: [
        {
          name: "question",
          type: "string",
          defaultValue: "Question",
        },
        {
          name: "answer",
          type: "richText",
          defaultValue: "Answer",
        },
        {
          name: "list",
          type: "list",
          subFields: [
            {
              name: "listItem",
              type: "string",
              defaultValue: "List Item",
            },
          ],
        },
        {
          name: "extraText",
          type: "richText",
          defaultValue: "Extra text below the answer",
        },
      ],
    },
  ],
});
</script>